<template>
  <v-row align="end">
    <v-col
      v-for="project in projects"
      :key="project.id"
      cols="12"
      sm="6"
      md="4"
      lg="2"
      xl="2"
    >
      <SmallCard :project="project" :actionsEnabled="false" :forceWrap="false" />
    </v-col>
  </v-row>
</template>
<script lang="ts" setup>
import type { TransformedProject } from "@/types";

defineProps<{
  projects: TransformedProject[];
}>();
</script>
